import { UntypedFormGroup } from '@angular/forms';
import { TranslocoService } from '@ngneat/transloco';
import { SelectItem } from 'primeng/api';

export class FormHelper {

  public static markFormAsDirty(form: UntypedFormGroup): void {
    (Object as any).values(form.controls).forEach((control: any) => {
      control.markAsDirty();
      if (control.controls) {
        FormHelper.markFormAsDirty(control);
      }
    });
  }

  public static disableForm(form: UntypedFormGroup, status: string | null, config: any): void {
    if (status !== null && config && config[status]) {
      const fields = config[status];
      if (Array.isArray(fields)) {
        fields.forEach((element: string) => {
          form.get(element).disable();
        });
      }
    }
  }

  public static setBackendErrors(form: UntypedFormGroup, fielderrors: any = null): void {
    if (fielderrors !== null) {
      for (const [name, data] of Object.entries(fielderrors)) {
        const errors: any = data;
        const errorObject: any = {};
        const count = 0;
        if (errors.length > 0) {
          errorObject['backend' + count] = {
            messages: errors
          };
          form.get(name)?.setErrors(errorObject);
        }
      }
    }
    FormHelper.markFormAsDirty(form);
  }

  public static getSelectList(values: any, emptyLabel: string = null, transloco: TranslocoService = null, translocoPrefix: string = null): Array<SelectItem> {
    const list: Array<SelectItem>  = [];
    if (emptyLabel !== null) {
      list.push({
        value: null,
        label: emptyLabel
      });
    }
    Object.keys(values).forEach((key: string | number) => {
      const translocoKey = (translocoPrefix !== null) ? translocoPrefix + '.' + values[key] : values[key] ;
      list.push({
        value: key,
        label: (transloco !== null) ? transloco.translate(translocoKey) : translocoKey
      });
    });
    return list;
  }

}
